import classNames from 'classnames'
import * as React from 'react'
import {render} from 'storyblok-rich-text-react-renderer'

import {isEmptyRichtext, unwrapAllNodeResolvers} from '@/common/utils'

const themes = {
  default: 'misc-button-s w-fit rounded-3xl border border-violet-600 px-3 py-1 text-violet-600',
  sticker: 'heading-xs-millik text-violet-400 bg-yellow-400 px-4 py-2 rounded-xl',
}

const Kicker = ({className, kicker, theme}) => {
  return isEmptyRichtext(kicker) ? null : (
    <span className={classNames(themes[theme || 'default'], className)}>
      {render(kicker, {nodeResolvers: unwrapAllNodeResolvers})}
    </span>
  )
}

export default Kicker
